import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import store from '@/app/store/store'
import {
  GuideCategoryApiRequest,
  UpdateGuideCategoryRequest,
  DeleteGuideCategoryRequest,
} from '@/data/payload/api/GuideCategoryRequest'
import { GuideCategoryPresenter } from '@/app/ui/presenters/GuideCategoryPresenter'
import { GuideCategory } from '@/domain/entities/GuideCategory'
import router from '@/router'
import Vue from 'vue'
import { AuthModule } from './auth'

export interface GuideCategoryState {
  guideCategoryData: GuideCategory
  isLoading: boolean
  fields: any
  paginationParam: Object
}

@Module({ namespaced: true, dynamic: true, store, name: 'guideCategory' })
class GuideCategories extends VuexModule implements GuideCategoryState {
  public guideCategoryData = new GuideCategory(true, '')
  public isLoading = true
  public Pages = 0
  public Limit = 10
  public fields = [
    { key: 'selected', sortable: false },
    { key: 'no', sortable: false },
    { key: 'name', sortable: true },
    { key: 'totalFiles', sortable: false },
    { key: 'isActive', sortable: false },
    { key: 'updatedAt', sortable: false },
    { key: 'createdAt', sortable: false },
    { key: 'actions', sortable: false },
  ]
  public paginationParam = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'CreateDate',
      type: 'desc',
      Materialtype: 'SOP',
    },
    category: 'guide',
  }

  @Action
  public async getGuideCategoryData() {
    this.setLoading(true)
    const presenter = await container.resolve(GuideCategoryPresenter)
    presenter
      .loadGuideCategories(this.paginationParam)
      .then((res: GuideCategory) => {
        this.setLoading(false)
        this.setGuideCategoryData(res)
        this.setpages(this.paginationParam.paging.page)
        this.setlimit(this.paginationParam.paging.limit)
        //  console.log('data', res)
      })
      .catch((error) => {
        this.setLoading(false)
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        router.push('/404/index')
        console.error('error', error)
      })
  }

  @Action
  public async postGuideCategory(params: {
    name: string
    isActive: boolean
    imageCoverId: number
    imageThumbnailId: number
    imageLogoId: number
    tag: string
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(GuideCategoryPresenter)
    presenter
      .postGuideCategories(
        new GuideCategoryApiRequest(
          params.name,
          params.isActive,
          params.imageCoverId,
          params.imageThumbnailId,
          params.imageLogoId,
          params.tag
        )
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Guide Category',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getGuideCategoryData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Action
  public async updateGuideCategory(params: {
    id: number
    name: string
    isActive: boolean
    imageCoverId: number
    imageThumbnailId: number
    imageLogoId: number
    tag: string
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(GuideCategoryPresenter)
    presenter
      .updateGuideCategories(
        new UpdateGuideCategoryRequest(
          params.name,
          params.isActive,
          params.imageCoverId,
          params.imageThumbnailId,
          params.imageLogoId,
          params.tag
        ),
        params.id
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Guide Category',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getGuideCategoryData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Action
  public async deleteGuideCategory(params: { ids: any }) {
    this.setLoading(true)
    const presenter = await container.resolve(GuideCategoryPresenter)
    presenter
      .deleteGuideCategories(new DeleteGuideCategoryRequest(params.ids))
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Guide Category',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getGuideCategoryData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Mutation
  private setGuideCategoryData(guideCategory: GuideCategory) {
    this.guideCategoryData = guideCategory
  }

  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }
  @Mutation
  private setpages(pages: number) {
    this.Pages = pages
  }
  @Mutation
  private setlimit(limit: number) {
    this.Limit = limit
  }
}

export const GuideCategoryDataModule = getModule(GuideCategories)
